import { Reducer } from 'redux';
import { ElementRefState, ElementRefTypes } from './types';

const INITIAL_STATE: ElementRefState = {
  currentRef: '',
};

const reducer: Reducer<ElementRefState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // CASES DRAWER
    case ElementRefTypes.SET_CURRENT_REF:
      return {
        ...state,
        currentRef: action.payload.currentRef,
      };

    default:
      return state;
  }
};

export default reducer;
